import { render, staticRenderFns } from "./BFR.vue?vue&type=template&id=faf2e13e&scoped=true&"
import script from "./BFR.vue?vue&type=script&lang=js&"
export * from "./BFR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2e13e",
  null
  
)

export default component.exports